import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import {
  useStylesTF,
  useStylesTD,
  useStylesSetting,
} from "../../../St/comps/UseStyle";
import { useEffect } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import Swipeable from "../../../Fronts/Main/Swipeable";
import axios from "axios";
import toast from "react-hot-toast";
import { uri } from "../../../help/Api";
import { useTranslation } from "react-i18next";

export default function ZatcaForm(props) {
  const { object, data, onChange } = props;
  const { t } = useTranslation(["forms"]);

  const clasTF = useStylesTF();

  const [submiting, setSubmiting] = useState(false);

  const onChangeData = (propName) => (e) => {
    onChange(null, { name: [propName], value: e.target.value });
  };
  const classesStt = useStylesSetting();

  return (
    <React.Fragment>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="Email"
            label={t("email")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("email")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="Email"
            value={object.Email}
            onChange={onChangeData("Email")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="VatNum"
            label={t("tax-number")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("tax-number")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="VatNum"
            value={object.VatNum}
            onChange={onChangeData("VatNum")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="BranchName`"
            label={t("point-name")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("point-name")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="BranchName"
            value={object.BranchName}
            onChange={onChangeData("BranchName")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="TaxPayerName`"
            label={t("organization-company-name")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("organization-company-name")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="TaxPayerName"
            value={object.TaxPayerName}
            onChange={onChangeData("TaxPayerName")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="InvoiceTypeCode`"
            label={t("invoice-type-code")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("invoice-type-code")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="InvoiceTypeCode"
            value={object.InvoiceTypeCode}
            onChange={onChangeData("InvoiceTypeCode")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="Address`"
            label={t("address")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("address")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="Address"
            value={object.Address}
            onChange={onChangeData("Address")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <TextField
            variant="outlined"
            size="small"
            id="Category"
            label={t("activity-type")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("activity-type")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="Category"
            value={object.Category}
            onChange={onChangeData("Category")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="CRN`"
            label={t("commercial-register")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("commercial-register")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="CRN"
            value={object.CRN}
            onChange={onChangeData("CRN")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="AdditionalStreetAddress`"
            label={t("additional-number")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="AdditionalStreetAddress"
            value={object.AdditionalStreetAddress}
            onChange={onChangeData("AdditionalStreetAddress")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="BuildingNumber`"
            label={t("building-number")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("building-number")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="BuildingNumber"
            value={object.BuildingNumber}
            onChange={onChangeData("BuildingNumber")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="CityName`"
            label={t("city")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="CityName"
            value={object.CityName}
            onChange={onChangeData("CityName")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="StreetName`"
            label={t("street-name")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("street-name")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="StreetName"
            value={object.StreetName}
            onChange={onChangeData("StreetName")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="DistrictName"
            label={t("district")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder={t("district")}
            type="text"
            InputLabelProps={{ shrink: true }}
            name="DistrictName"
            value={object.DistrictName}
            onChange={onChangeData("DistrictName")}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} md={12} sm={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="PostalCode`"
            label={t("postal-code")}
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="PostalCode"
            value={object.PostalCode}
            onChange={onChangeData("PostalCode")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            variant="outlined"
            size="small"
            id="OTP`"
            label="OTP"
            // className={clasTF.rootSer}
            InputProps={{ className: clasTF.input }}
            placeholder=""
            type="text"
            InputLabelProps={{ shrink: true }}
            name="OTP"
            value={object.OTP}
            onChange={onChangeData("OTP")}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  fullWidth
                  checked={object?.IsProductionCsr == 1}
                  onChange={(e) =>
                    onChange(null, {
                      name: "IsProductionCsr",
                      value: e.target.checked ? 1 : 0,
                    })
                  }
                  name="IsProductionCsr"
                />
              }
              size="small"
              color="primary"
              fontSize="small"
              label={t("production-mode")}
            />
          </FormGroup>
        </Grid>
      </Grid>

      <Grid container item lg={12} md={12} xs={12}></Grid>
    </React.Fragment>
  );
}
